export default __webpack_public_path__ + "static/media/Cigna.a97b24d2.png";